import { OptionProps } from 'react-apollo';
import { Props } from '.';
import {
  StockPriceQuery,
  StockPriceQueryVariables,
} from 'queries/StockPrice/__generated__/StockPriceQuery';
import { mapAskPrice } from 'queries/StockPrice/selectors';

export {
  StockPriceQuery,
  StockPriceQueryVariables,
} from 'queries/StockPrice/__generated__/StockPriceQuery';

export const responseToProps = ({
  data,
}: OptionProps<Props, StockPriceQuery, StockPriceQueryVariables>) => mapAskPrice(data);

export type Data = ReturnType<typeof responseToProps>;
